import React from 'react';

const EquipmentFormModal = ({
  isDialogOpen,
  editingEquipment,
  formData,
  setFormData,
  handleSubmit,
  resetForm,
}) => {
  if (!isDialogOpen) return null;

  const title = editingEquipment ? 'Editar Equipo' : 'Crear Nuevo Equipo';

  const handleFieldChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement>) => {
    const { name, value, type, checked } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value,
    }));
  };

  const inputClass = 'focus:ring-primary-main w-full rounded border bg-black px-3 py-2 focus:outline-none focus:ring';

  return (
    <div className="fixed text-white inset-0 z-50 flex items-center justify-center bg-black bg-opacity-40">
      <div className="bg-primary-dark max-w-lg rounded p-6 shadow-lg sm:w-full max-h-[90vh] overflow-y-auto">
        <h3 className="mb-4 text-xl font-semibold">{title}</h3>
        <form onSubmit={handleSubmit} className="space-y-4">

          <div className="grid grid-cols-2 gap-4">

            {/* Nombre del Equipo (Obligatorio y Único) */}
            <div className="col-span-2">
              <label className="block text-sm font-medium">Nombre del Equipo</label>
              <input type="text" name="name" value={formData.name} onChange={handleFieldChange} className={inputClass} required />
            </div>

            {/* Fabricante */}
            <div>
              <label className="block text-sm font-medium">Fabricante</label>
              <input type="text" name="manufacturer" value={formData.manufacturer || ''} onChange={handleFieldChange} className={inputClass} />
            </div>

            {/* Modelo */}
            <div>
              <label className="block text-sm font-medium">Modelo</label>
              <input type="text" name="model" value={formData.model || ''} onChange={handleFieldChange} className={inputClass} />
            </div>

            {/* Número de Serie */}
            <div className="col-span-2">
              <label className="block text-sm font-medium">Número de Serie</label>
              <input type="text" name="serial_number" value={formData.serial_number || ''} onChange={handleFieldChange} className={inputClass} />
            </div>

            {/* Estado */}
            <div className="col-span-2 flex items-center gap-6 pt-2">
              <label className="flex items-center space-x-2 text-sm">
                <input type="checkbox" name="status" checked={formData.status} onChange={handleFieldChange} />
                <span>Activo/Inactivo</span>
              </label>
            </div>

          </div>

          <div className="flex justify-end gap-2 pt-4">
            <button type="button" onClick={resetForm} className="rounded bg-red-700 px-4 py-2 text-white hover:bg-red-500">Cancelar</button>
            <button type="submit" className="rounded bg-blue-600 px-4 py-2 text-white hover:bg-blue-900">
              {editingEquipment ? 'Actualizar' : 'Crear'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default EquipmentFormModal;
